import Vue from 'vue'
import App from './App'
import createRouter from './router'
import createStore from './store'
import './api'
import './assets/scss/index.scss'
// import './utils/flexible' // flexible方案
import Components from './components'
import Vant, {Dialog} from 'vant'
// import  from 'vant'
import VueMeta from 'vue-meta'
import 'vant/lib/index.css'
import Mixins from '@/utils/mixins'
import 'swiper/dist/css/swiper.css'
// 注册自定义指令
import importDirectives from './utils/directives'
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css'
import {interceptor} from './router/interceptor'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import Cube from 'cube-ui'
import dom from '@/utils/dom'
import VueProgressBar from 'vue-progressbar'
import appConfig from '@/config'
import {$error} from '@/utils/theme/colors.js'
import {initFilters} from '@/utils/filters'
import VueJsonp from 'vue-jsonp'
if (typeof window !== 'undefined') {
  const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr')
  Vue.use(VueAwesomeSwiper)
}
importDirectives(Vue)
initFilters(Vue)

Vue.use(VueJsonp)
Vue.use(Components)
// 有赞
Vue.use(Vant)
Vue.mixin(Mixins)
Vue.use(VueMeta)
Vue.use(MuseUI)
Vue.use(Cube)
const progressOptions = {
  color: '#09BB07', // wechat
  failedColor: $error,
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
}
Vue.use(VueProgressBar, progressOptions)

Vue.config.productionTip = false
Vue.prototype.$dom = dom
Vue.prototype.$config = appConfig
Vue.prototype.$dialog = Dialog

const router = createRouter()
const store = createStore()
interceptor(router, store)

new Vue({
  name: 'App',
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js